import React from "react";
import { useTranslation } from "react-i18next";

import { getColumnDefaultSortDirection } from "./utils";
import { ProjectsLocationsSearchParams } from "../hooks";

import "./styles.scss";

export interface IChangeSortButtonProps {
  searchParams: ProjectsLocationsSearchParams;
  setSearchParams: React.Dispatch<
    React.SetStateAction<ProjectsLocationsSearchParams>
  >;
  fieldName: string;
  translationKey: string;
}

export const ChangeSortButton: React.FunctionComponent<
  IChangeSortButtonProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`projectManagementPage.projectFacilitiesList.table.header.${key}`);

  const { searchParams, setSearchParams, fieldName, translationKey } = props;

  const handleChangeOrder = () => {
    setSearchParams((sp) => {
      const currentSort = sp.sort;
      const currentOrder = sp.order;
      const newSort = fieldName;
      let newOrder: "asc" | "desc" = "asc";

      // Swap order if the same field is clicked
      // Else, set to default sort direction for that column
      if (currentSort === newSort) {
        newOrder = currentOrder === "asc" ? "desc" : "asc";
      } else {
        newOrder = getColumnDefaultSortDirection(newSort);
      }

      return {
        ...sp,
        sort: newSort,
        order: newOrder
      };
    });
  };

  const buttonText =
    searchParams.sort !== fieldName
      ? t(`${translationKey}.default`)
      : t(`${translationKey}.${searchParams.order}`);

  return (
    <button
      className="project-facilities-list-change-sort-button"
      onClick={handleChangeOrder}
    >
      {buttonText}
    </button>
  );
};
